"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CauseCategories() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const stats = [{
    value: "12",
    label: "active campaigns",
    align: "left"
  }, {
    value: "45K+",
    label: "lives impacted",
    align: "right"
  }, {
    value: "100%",
    label: "transparency",
    align: "left"
  }];
  return <section data-section-id="2138" id="cause-categories" className="dark relative overflow-hidden bg-background text-foreground py-24 md:py-44 px-5 sm:px-8 lg:px-18" style={{
    backgroundColor: "hsl(45 30% 96%)",
    color: "hsl(155 40% 8%)"
  }}>
      {}
      <div aria-hidden="true" className="pointer-events-none absolute font-serif select-none leading-none" style={{
      fontSize: "clamp(12rem, 22vw, 22rem)",
      fontWeight: 200,
      color: "hsl(155 40% 8% / 0.05)",
      top: "8%",
      left: "2%",
      letterSpacing: "-0.05em"
    }}>
        01
      </div>

      <div className="relative mx-auto max-w-[1440px] grid grid-cols-12 gap-6 md:gap-8 items-start">
        {}
        <div ref={leftRef} className="col-span-12 lg:col-span-5 order-2 lg:order-1 flex flex-col" style={{
        opacity: leftVisible ? 1 : 0,
        transform: leftVisible ? "translateY(0)" : "translateY(24px)",
        transition: "opacity 640ms cubic-bezier(0.22, 1, 0.36, 1), transform 640ms cubic-bezier(0.22, 1, 0.36, 1)"
      }}>
          {}
          <div className="flex items-center gap-3 mb-8">
            <span aria-hidden="true" className="inline-block h-px w-6" style={{
            backgroundColor: "hsl(150 25% 45%)"
          }} />
            <span className="font-default uppercase" style={{
            fontSize: "clamp(0.6875rem, 0.78vw, 0.8125rem)",
            fontWeight: 600,
            letterSpacing: "0.15em",
            lineHeight: 1,
            color: "hsl(155 40% 8%)"
          }}>
              § MISSION // AWARENESS
            </span>
          </div>

          {}
          <h2 className="font-default mb-8" style={{
          fontSize: "clamp(2.25rem, 4.2vw, 4.25rem)",
          fontWeight: 500,
          lineHeight: 1.1,
          letterSpacing: "-0.02em",
          color: "hsl(155 40% 8%)"
        }}>
            Keeping issues <span className="italic">forever fresh</span> in the public eye.
          </h2>

          {}
          <p className="mb-12 max-w-xl font-default" style={{
          fontSize: "clamp(1.125rem, 1.25vw, 1.35rem)",
          fontWeight: 400,
          lineHeight: 1.6,
          color: "hsl(155 40% 8% / 0.8)"
        }}>
            We bridge the gap between urgent humanitarian advocacy and modern lifestyle culture. Every cause we support is a commitment to lasting change, fueled by community action and purpose-driven design.
          </p>

          {}
          <div className="flex flex-col gap-7 mb-12">
            {stats.map((stat, i) => <div key={i} data-index={i} className={`flex items-center gap-5 ${stat.align === "right" ? "flex-row-reverse text-right" : ""}`}>
                <div className="relative flex items-center flex-1 min-w-0">
                  <span className="h-px flex-1" style={{
                backgroundColor: "hsl(150 25% 45%)"
              }} />
                  <span aria-hidden="true" className="block h-1.5 w-1.5 rounded-lg ml-0" style={{
                backgroundColor: "hsl(20 40% 50%)"
              }} />
                </div>
                <div className="flex items-baseline gap-3 shrink-0">
                  <span className="font-default" style={{
                fontSize: "clamp(1.75rem, 2.5vw, 2.5rem)",
                fontWeight: 500,
                letterSpacing: "-0.02em",
                color: "hsl(155 40% 8%)",
                lineHeight: 1
              }}>
                    {stat.value}
                  </span>
                  <span className="font-default uppercase" style={{
                fontSize: "0.75rem",
                letterSpacing: "0.15em",
                color: "hsl(155 40% 8% / 0.6)"
              }}>
                    / {stat.label}
                  </span>
                </div>
              </div>)}
          </div>

          {}
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/CurrentCausesPage">
              <Button className="rounded-lg px-8 py-6 h-auto font-default uppercase transition-all duration-300 ease-out hover:-translate-y-0.5" style={{
              backgroundColor: "hsl(155 35% 12%)",
              color: "hsl(45 30% 96%)",
              fontSize: "0.875rem",
              fontWeight: 600,
              letterSpacing: "0.05em"
            }}>
                Explore Causes
              </Button>
            </Link>
            <Link to="/ShopPage">
              <Button variant="outline" className="rounded-lg px-8 py-6 h-auto font-default uppercase bg-transparent transition-colors duration-300 ease-out" style={{
              borderColor: "hsl(155 35% 12%)",
              color: "hsl(155 35% 12%)",
              fontSize: "0.875rem",
              fontWeight: 600,
              letterSpacing: "0.05em",
              borderWidth: "1.5px"
            }}>
                Shop Current Drop
              </Button>
            </Link>
          </div>
        </div>

        {}
        <div ref={rightRef} className="col-span-12 lg:col-span-7 order-1 lg:order-2" style={{
        opacity: rightVisible ? 1 : 0,
        transform: rightVisible ? "translateY(0)" : "translateY(24px)",
        transition: "opacity 640ms cubic-bezier(0.22, 1, 0.36, 1) 80ms, transform 640ms cubic-bezier(0.22, 1, 0.36, 1) 80ms"
      }}>
          <div className="relative w-full" style={{
          aspectRatio: "16 / 10"
        }}>
            {}
            <span aria-hidden="true" className="absolute top-0 left-0 z-10" style={{
            width: "16px",
            height: "16px",
            borderTop: "1px solid hsl(155 40% 8% / 0.2)",
            borderLeft: "1px solid hsl(155 40% 8% / 0.2)"
          }} />
            <span aria-hidden="true" className="absolute top-0 right-0 z-10" style={{
            width: "16px",
            height: "16px",
            borderTop: "1px solid hsl(155 40% 8% / 0.2)",
            borderRight: "1px solid hsl(155 40% 8% / 0.2)"
          }} />
            <span aria-hidden="true" className="absolute bottom-0 left-0 z-10" style={{
            width: "16px",
            height: "16px",
            borderBottom: "1px solid hsl(155 40% 8% / 0.2)",
            borderLeft: "1px solid hsl(155 40% 8% / 0.2)"
          }} />
            <span aria-hidden="true" className="absolute bottom-0 right-0 z-10" style={{
            width: "16px",
            height: "16px",
            borderBottom: "1px solid hsl(20 40% 50%)",
            borderRight: "1px solid hsl(20 40% 50%)"
          }} />

            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717563/img/humanitarian_awareness_community.png" alt="Community members gathering for a humanitarian awareness event in a warm, natural setting" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover rounded-lg" />

            {}
            <div className="absolute bottom-4 left-4 z-10 font-default uppercase" style={{
            fontSize: "0.75rem",
            letterSpacing: "0.1em",
            lineHeight: 1.2,
            color: "hsl(45 30% 96%)"
          }}>
              Campaign N° 012 — Community Action / 2024
            </div>
          </div>
        </div>
      </div>
    </section>;
}